import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

function OwnerTypeDetails() {
    const navigate = useNavigate();
    const location = useLocation();
    const ownerTypeDetails = location.state?.ownerTypeDetails || {};

    return (
        <div>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="page-header">
                            <div className='row text-end'>
                                <div className='col'>
                                    <button type="button" class="btn btn-danger"
                                        style={{
                                            backgroundColor: "rgb(236, 17, 23)"
                                        }}
                                        onClick={() => navigate("/owner-type")}
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>
                            <h4 style={{ display: "flex", marginBottom: "30px" }}>
                                Owner Type Details of :  {ownerTypeDetails.owner_type}
                            </h4>
                            <div className="card">
                                <div className="p-3">
                                    <div className="text-start mb-3">
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Owner Type</label>
                                                    <input
                                                        type="text"
                                                        name="owner_type"
                                                        className="form-control"
                                                        readOnly
                                                        value={ownerTypeDetails.owner_type}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Status</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="status"
                                                        readOnly
                                                        value={ownerTypeDetails.status === "1" ? "Active" : "Inactive"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OwnerTypeDetails
